import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import ItemsList from "../../../components/ItemsList/ItemsList";
import "./Rating.scss";
import { totalValue } from "../Board";
import ReloadIcon from "../../../components/ReloadIcon/ReloadIcon";
import { getStatistic } from "../../../request/user";
import { getColorClassName } from "../../CalendarPage";

export default memo(function Rating() {
  const [elements, setElements] = useState(null);
  const [total, setTotal] = useState(null);

  const [showReloadIcon, setShowReloadIcon] = useState(false);
  useEffect(() => {
    const get = async () => {
      await reload();
    };
    get().catch((err) => console.error(err));

    const intervalCall = setInterval(async () => {
      await reload();
    }, 60000 * 5);
    return () => {
      // clean up
      clearInterval(intervalCall);
    };
  }, []);

  const reload = async () => {
    setShowReloadIcon(false);
    await setTimeout(() => {
      getData();
    }, 10);
  };

  const getData = useCallback(async () => {
    try {
      const res = await getStatistic(true);
      setElements(format(res?.data?.data));
      setShowReloadIcon(true);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const tableHeaders = useMemo(() => {
    return [
      {
        field: "assignee",
        headerName: "Assignee",
        sortable: false,
        type: "string",
        maxWidth: 200,
        flex: 1,
        renderCell: (item) => (
          <div className="nowrap">
            {item.row?.user?.name}
            {
              item?.row?.calendar?.type && <span> [{item?.row?.calendar?.timeStart} - {item?.row?.calendar?.timeEnd}] {item?.row?.calendar?.location??''} </span>
            }
            {
              item?.row?.calendar?.onboarding && <span className={getColorClassName('onb')}>[OnB]</span>
            }
          </div>
        ),
      },
      {
        field: "taken",
        headerName: "Taken",
        flex: 1,
        type: "number",
        renderCell: (item) => <span>{parseInt(item.value)}</span>,
      },
      {
        field: "closed",
        headerName: "Closed",
        flex: 1,
        type: "number",
        renderCell: (item) => <span>{parseInt(item.value)}</span>,
      },
    ];
  }, []);

  const format = useCallback((items) => {
    if (!items) return;
    let arr = items.map((el) => {
      el.id = el.id ?? el.user_id;
      el.taken = el.summary?.today_total;
      el.closed = el.summary?.today_done;
      
      el.taken = el.taken < 0 ? 0 : el.taken;
      el.closed = el.closed < 0 ? 0 : el.closed;
      return el;
    });

    // const sorterDesc = (sortBy) => (a, b) => a[sortBy] > b[sortBy] ? -1 : 1;
    // arr.sort(sorterDesc("taken"));

    return arr;
  }, []);

  useEffect(() => {
    if (elements !== null) {
      const totalTaken = totalValue(elements, "taken");
      const totalClosed = totalValue(elements, "closed");

      setTotal({ taken: totalTaken, closed: totalClosed });
    }
  }, [elements]);

  return (
    <div className="block-inner">
      <div className="mb-15">
        <div className="flex mb-15">
          <div>
            <Typography variant="h6">Rating</Typography>
          </div>
          <div className="pl-15">
            {!!showReloadIcon && (
              <div
                className="reload-btn"
                title="Reload"
                onClick={() => {
                  reload();
                }}
              >
                {" "}
                <ReloadIcon timeout={60 * 5} />
              </div>
            )}
          </div>
        </div>
      </div>
      {elements && (
        <>
          <ItemsList
            items={elements}
            headers={tableHeaders}
            defaultPageSize={elements.length}
            totalCount={elements.length}
            gridId="rating-grid"
            defaultSortModel={{ field: "taken", sort: "desc" }}
          />
          {!!total && (
            <Grid
              className="total-bottom"
              container
              style={{ textAlign: "right" }}
            >
              <Grid item xs={4} style={{ textAlign: "left" }}>
                Total
              </Grid>
              <Grid item xs={4}>
                {total.taken}
              </Grid>
              <Grid item xs={4}>
                {total.closed}
              </Grid>
            </Grid>
          )}
        </>
      )}
    </div>
  );
});
